
export enum ConsigneeType {
  INSS = 'INSS',
  BARI = 'BARI',
  DEFAULT = 'DEFAULT',
}

/** IDs do Cartão Benefício INSS (RCC/RMC). Usado nas regras de campos do formulário. */
export const INSS_CARD_IDS = [18, 19, 20];

/** Aposentados e Pensionistas INSS (ID: 1). Relevante apenas para a regra de documentos. */
export const INSS_RETIREE_ID = 1;

/** Grupo Barigui (4) e Grupo Financeiro Bari (21). Exibem campos extras (CNPJ + Razão Social). */
export const BARI_IDS = [4, 21];
